import { useDispatch } from "../../store"
import { closeModal } from "../../store/modal/actions"
import CloseIcon from "../../components/icons/CloseIcon"
import DownloadIcon from "../../components/icons/DownloadIcon"
import { useIsHeLanguage } from "../../hooks"
import classNames from "classnames"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

export type ImageViewerModalProps = {
    isOpen: boolean
    params: {
        src: string
    }
}

export const ImageViewerModal = ({ isOpen, params }: ImageViewerModalProps) => {
    if (!isOpen || !params?.src) return null

    const { src } = params
    const { t } = useTranslation()
    const { isHeLanguage } = useIsHeLanguage()
    const dispatch = useDispatch()

    const download = async (url: string, filename = "image.jpg") => {
        try {
            const response = await fetch(url)
            const blob = await response.blob()
            const link = document.createElement("a")
            link.href = URL.createObjectURL(blob)
            link.download = filename
            link.click()
            URL.revokeObjectURL(link.href)
        } catch (e) {
            toast.error(e.message)
        }
    }

    const buttonClassNames = classNames(
        "p-2 border-2 rounded-full",
        "bg-very-light-green bg-opacity-60 hover:bg-opacity-100",
        "border-opacity-40 border-med-black"
    )

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center"
            onClick={() => dispatch(closeModal())}
        >
            <div className={classNames("absolute top-4 flex gap-3", isHeLanguage ? "left-4" : "right-4")}>
                <button
                    onClick={async (e) => {
                        e.stopPropagation()
                        await download(src)
                    }}
                    className={buttonClassNames}
                    title={t("common:download")}
                >
                    <DownloadIcon width={24} height={24} color="med-black" />
                </button>

                <button
                    onClick={() => dispatch(closeModal())}
                    className={buttonClassNames}
                    title={t("common:close")}
                >
                    <CloseIcon width={24} height={24} color="med-black" />
                </button>
            </div>

            <img
                src={src}
                alt="preview"
                className="max-w-full max-h-full object-contain"
                onClick={(e) => e.stopPropagation()}
            />
        </div>
    )
}
